import { render, staticRenderFns } from "./TradeTerms.vue?vue&type=template&id=518f1005&"
import script from "./TradeTerms.vue?vue&type=script&lang=js&"
export * from "./TradeTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports